import type { DialogInitial } from "./AgendaAppointmentDialog";

type ConsultaDaLista = {
  id: string;
  date: string | Date;
  startTime: string;
  endTime: string;
  patientId?: string | null;
  patientName?: string;
  patientPhone?: string | null;
  dentistId?: string | null;
  dentistName?: string | null;
  services?: { serviceId: string }[];
  procedure?: string;
  status?: DialogInitial["status"];
  notes?: string | null;
  sendReminder?: boolean;
  color?: string | null;
  salaId?: string | null;
  sala?: { id: string; nome: string; cor: string | null } | null;
};

/** A consulta como vem de `appointment.listByRange`, no formato do diálogo em modo edição — o mesmo
 *  da Agenda e do "Remarcar" do Início. */
export function consultaParaEdicao(appt: ConsultaDaLista): DialogInitial {
  return {
    id: appt.id,
    date: new Date(appt.date),
    startTime: appt.startTime,
    endTime: appt.endTime,
    patientId: appt.patientId,
    patientName: appt.patientName,
    patientPhone: appt.patientPhone ?? undefined,
    dentistId: appt.dentistId,
    dentistName: appt.dentistName ?? undefined,
    serviceIds: (appt.services ?? []).map((s) => s.serviceId),
    procedure: appt.procedure,
    status: appt.status,
    notes: appt.notes ?? undefined,
    sendReminder: appt.sendReminder,
    color: appt.color,
    salaId: appt.salaId ?? null,
    sala: appt.sala ?? null,
  };
}
